import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=10ec769c&"
import script from "./MemberProfile.vue?vue&type=script&lang=js&"
export * from "./MemberProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QInput,QCheckbox,QChip,QSelect,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QInput,QCheckbox,QChip,QSelect,QBtn,QIcon})
